import PropTypes from 'prop-types';
import { BsArrowsAngleExpand } from 'react-icons/bs';

import { getStateColors } from './callOverlayUtils';
import PulsingDot from './PulsingDot';

const MinimizedCallOverlay = ({
	bottomClass,
	label,
	displayNumber,
	primaryName,
	isRinging,
	isActive,
	durationText,
	DirectionIcon,
	onExpand,
}) => {
	const colors = getStateColors(isRinging, isActive);
	// When the caller is resolved, lead with the name and show the state label below it;
	// otherwise lead with the state label and show the raw number.
	const title = primaryName || label;
	const subtitle = primaryName ? label : displayNumber;

	return (
		<div
			onClick={onExpand}
			className={`fixed ${bottomClass} right-4 z-40 w-[340px] bg-white rounded-card border border-bgBase-500 shadow-elevated cursor-pointer transition duration-200 hover:-translate-y-0.5 hover:border-primary-300 group`}
		>
			<div className="px-4 py-3 flex items-center gap-3">
				<PulsingDot colors={colors} showPulse={isRinging || isActive} />
				<div
					className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${colors.bg} ${colors.text}`}
				>
					<DirectionIcon className="w-3.5 h-3.5" />
				</div>
				<div className="min-w-0 flex-1">
					<p className="text-xs font-semibold text-text truncate">{title}</p>
					{subtitle && (
						<p className={`text-[10px] text-bgBase-800 truncate ${primaryName ? '' : 'font-mono'}`}>
							{subtitle}
						</p>
					)}
				</div>
				{durationText && (
					<span className="text-[10px] font-semibold text-bgBase-800 tabular-nums flex-shrink-0">
						{durationText}
					</span>
				)}
				<div className="flex items-center gap-1 flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
					<button
						onClick={(e) => {
							e.stopPropagation();
							onExpand();
						}}
						className="p-1 text-bgBase-800 hover:text-text rounded"
						title="Erweitern"
					>
						<BsArrowsAngleExpand className="w-3 h-3" />
					</button>
				</div>
			</div>
			<div className="h-0.5 rounded-b-card overflow-hidden">
				<div className={`h-full w-full ${colors.bar}`} />
			</div>
		</div>
	);
};

MinimizedCallOverlay.propTypes = {
	bottomClass: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	displayNumber: PropTypes.string,
	primaryName: PropTypes.string,
	isRinging: PropTypes.bool.isRequired,
	isActive: PropTypes.bool.isRequired,
	durationText: PropTypes.string,
	DirectionIcon: PropTypes.elementType.isRequired,
	onExpand: PropTypes.func.isRequired,
};

export default MinimizedCallOverlay;
